import { Component, Input } from '@angular/core';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-scrolldown-button',
    templateUrl: './scrolldown-button.component.html',
    styleUrls: ['./scrolldown-button.component.scss'],
    standalone: false
})
export class ScrolldownButtonComponent {

  @Input() scrollDown = 100;
  @Input() section = 'main';
  faAngleDown = faAngleDown;

  /**
   * Scrolls the page down by the amount of pixels specified in the scrollDown property.           
   * @returns None           
   */
  setScrollDown() {
    const section = <HTMLElement>document.getElementById(this.section);
    section.scrollBy({
      top: this.scrollDown,
      left: 0,
      behavior: "smooth",
    })
  }
}
